import { render, staticRenderFns } from "./edit-attention.vue?vue&type=template&id=030c2f62"
import script from "./edit-attention.vue?vue&type=script&lang=js"
export * from "./edit-attention.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports